import { useIonRouter } from "@ionic/react";
import { useEffect, useRef } from "react";
import "./Avatar.css";
import { loonlogAvatarSvg } from "./Avatar2";
import { useSelector } from "react-redux";

function Avatar({
  username,
  avatar,
  province,
  size = "sm",
  className = "",
  style = {},
  isProfilePage = false,
  latestAvatarPostId = null,
  isAdmin = false,
  isFounder = false,
  isNewPostAvatar = false,
  isOfficial = false,
}) {
  const router = useIonRouter();
  const suppressNextClickRef = useRef(false);

  let sizePx = null;
  if (typeof size === "number") {
    sizePx = size;
  }

  const getSizeClass = () => {
    if (
      size === "sm" ||
      size === "md" ||
      size === "lg" ||
      size === "lg--new-post"
    )
      return `avatar--${size}`;
    else return "avatar--md";
  };

  const getInitials = (userStr) => {
    const cleanUser = (userStr || "").replace("@", "").trim();
    if (!cleanUser) return "?";
    const camelParts = cleanUser.split(/(?=[A-Z])/).filter(Boolean);
    const first = camelParts[0]?.[0] || cleanUser[0];
    const second =
      camelParts.length > 1 ? camelParts[1][0] : cleanUser[1] || "";
    return (first + second).toUpperCase();
  };

  const handleClick = (e) => {
    if (e) e.stopPropagation();
    if (suppressNextClickRef.current) {
      suppressNextClickRef.current = false;
      return;
    }
    if (e && e.preventDefault) e.preventDefault();
    // STEP A: If we are already on the profile page, go to the Post
    if (isProfilePage && latestAvatarPostId) {
      return router.push(`/post/${latestAvatarPostId}`);
    }
    router.push(`/profile/${username}`);
  };

  const containerStyle = { ...style };
  if (sizePx) {
    containerStyle.width = `${sizePx}px`;
    containerStyle.height = `${sizePx}px`;
    containerStyle.minWidth = `${sizePx}px`;
  }
  const handleClickNewPostAvatar = (e) => {
    if (e) e.stopPropagation();
    if (e && e.preventDefault) e.preventDefault();
    router.push("/new-post");
  };
  return (
    <div className={`avatar-container ${className} `}>
      <div className="avatar-wrapper">
        <div
          className={`avatar ${getSizeClass()} ${isAdmin ? "avatar__image--admin" : ""}  ${isFounder ? "avatar__image--founder" : ""}`}
          aria-label={`${username}'s profile`}
          onClick={isNewPostAvatar ? handleClickNewPostAvatar : handleClick}
          style={containerStyle}
        >
          <img
            src={avatar ? avatar : loonlogAvatarSvg(username, province)}
            alt={username}
            loading="eager"
            decoding="async"
            className={`avatar__image`}
          />
          {/* {avatar ? (
          <img
          src={avatar}
          alt={username}
          loading="eager"
          decoding="async"
          className="avatar__image"
          />
          ) : (
            
          // <Avatar2 name={username} province={province} />
          // <span className="avatar__initials-text">{getInitials(username)}</span>
          )} */}
        </div>
        {/* THE ADMIN CHECKMARK */}
        {isOfficial && (
          <div className="admin-checkmark">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                fill="white"
              />
            </svg>
          </div>
        )}
        {/* THE FOUNDER BADGE */}
        {isFounder && (
          <div className="founder-badge">
            <span role="img" aria-label="Founder">
              ⭐
            </span>
          </div>
        )}
        {/* {!avatar && province && <div className="avatar-badge">{province}</div>} */}
      </div>
    </div>
  );
}
export default Avatar;
